webpackJsonp([222368950809299],{

/***/ 152:
/***/ (function(module, exports) {

	module.exports = {"layoutContext":{}}

/***/ }),

/***/ 295:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _content = __webpack_require__(307);
	
	var _content2 = _interopRequireDefault(_content);
	
	var _layoutContent = __webpack_require__(152);
	
	var _layoutContent2 = _interopRequireDefault(_layoutContent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_content2.default, _extends({}, props, _layoutContent2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 34:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(17);

/***/ }),

/***/ 74:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _icon = __webpack_require__(21);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	__webpack_require__(34);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(16);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Header = function (_React$Component) {
	  _inherits(Header, _React$Component);
	
	  function Header() {
	    _classCallCheck(this, Header);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this));
	
	    _this.state = {
	      open: false
	    };
	    _this.toggleNav = _this.toggleNav.bind(_this);
	    _this.closeNav = _this.closeNav.bind(_this);
	    return _this;
	  }
	
	  Header.prototype.toggleNav = function toggleNav() {
	    this.setState({ open: !this.state.open });
	  };
	
	  Header.prototype.closeNav = function closeNav() {
	    this.setState({ open: false });
	  };
	
	  Header.prototype.render = function render() {
	
	    var showNav = _react2.default.createElement(
	      'div',
	      { className: 'header--res--nav' },
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: '/articles', activeClassName: 'active', onClick: this.closeNav },
	        'Articles'
	      ),
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: '/open-source', activeClassName: 'active', onClick: this.closeNav },
	        'Open Source'
	      ),
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: '/store', activeClassName: 'active', onClick: this.closeNav },
	        'Store'
	      ),
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: '/about-me', activeClassName: 'active', onClick: this.closeNav },
	        'About Me'
	      ),
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: '/contact', activeClassName: 'active', onClick: this.closeNav },
	        'Contact'
	      ),
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: '/archive', activeClassName: 'active', onClick: this.closeNav },
	        'Archive'
	      ),
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: '/newsletter', activeClassName: 'active', onClick: this.closeNav },
	        'Newsletter'
	      )
	    );
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'component--header' },
	      _react2.default.createElement(
	        'div',
	        { className: 'inner' },
	        _react2.default.createElement(
	          'h1',
	          null,
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: '/' },
	            'Dhruv Kumar Jha'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'flex' },
	          _react2.default.createElement(
	            'nav',
	            { className: 'primary--nav--new' },
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: '/articles', activeClassName: 'active' },
	              'Articles'
	            ),
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: '/open-source', activeClassName: 'active' },
	              'Open Source'
	            ),
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: '/store', activeClassName: 'active' },
	              'Store'
	            ),
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: '/about-me', activeClassName: 'active' },
	              'About Me'
	            ),
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: '/contact', activeClassName: 'active' },
	              'Contact'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'primary--nav--res' },
	            _react2.default.createElement(_icon2.default, { type: 'bars', className: this.state.open ? 'toggle-icon active' : 'toggle-icon', onClick: this.toggleNav }),
	            this.state.open && showNav
	          )
	        )
	      )
	    );
	  };
	
	  return Header;
	}(_react2.default.Component);
	
	exports.default = Header;
	module.exports = exports['default'];

/***/ }),

/***/ 307:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(16);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Header = __webpack_require__(74);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContentLayout = function ContentLayout(_ref) {
	  var children = _ref.children;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_Header2.default, null),
	    _react2.default.createElement(
	      'div',
	      { className: 'wrapper--default-content' },
	      _react2.default.createElement(
	        'div',
	        { className: 'default--typography' },
	        children()
	      )
	    )
	  );
	};
	
	exports.default = ContentLayout;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-content-js-3d8ba9e3f4db37dea34c.js